// ttsPlayer.js

// TTS endpoint is proxied directly at /tts (not /lb-api/tts)
// See Apache config: ProxyPass "/tts" "http://127.0.0.1:5001/tts"
const TTS_ENDPOINT = "/tts";

let currentAudio = null;
let muted = false;
let avatarSpeaking = false;
let currentVideo = null;

// CHANGED: keep stable handler references so removeEventListener works
let onAudioPlay = null;
let onAudioPause = null;
let onAudioEnded = null;
let onAudioError = null;

export function getCurrentAudio() {
  return currentAudio;
}

export function isAvatarSpeaking() {
  return avatarSpeaking;
}

export async function speakWithAvatar(text, videoElement, voice = "Joanna") {
  stopAvatarSpeech();
  avatarSpeaking = true;
  currentVideo = videoElement;

  try {
    // Truncate text to Polly's limit (2900 chars to be safe)
    const safeText = text && text.length > 2900 ? text.substring(0, 2900) : text;

    const res = await fetch(TTS_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ text: safeText, voice })
    });

    if (!res.ok) {
      console.error("TTS request failed:", res.status);
      avatarSpeaking = false;
      return;
    }

    const audioBlob = await res.blob();
    const audioUrl = URL.createObjectURL(audioBlob);
    currentAudio = new Audio(audioUrl);

    // Ensure video is ready but paused
    if (currentVideo) {
      currentVideo.currentTime = 0;
      currentVideo.pause();
    }

    // CHANGED: stable listeners
    onAudioPlay = () => {
      if (currentVideo) {
        currentVideo.play().catch(console.error);
      }
    };

    onAudioPause = () => {
      if (currentVideo) {
        currentVideo.pause();
      }
    };

    onAudioEnded = () => {
      stopAvatarSpeech();
    };

    onAudioError = (e) => {
      console.error("Audio playback error:", e);
      stopAvatarSpeech();
    };

    currentAudio.addEventListener("play", onAudioPlay);
    currentAudio.addEventListener("pause", onAudioPause);
    currentAudio.addEventListener("ended", onAudioEnded);
    currentAudio.addEventListener("error", onAudioError);

    // Start playing audio (video will start automatically via event listener)
    if (!muted) {
      currentAudio.play().catch(console.error);
    }
  } catch (error) {
    console.error("TTS error:", error);
    avatarSpeaking = false;
  }
}

export function toggleMute(forceMute = null) {
  if (forceMute !== null) {
    muted = forceMute;
  } else {
    muted = !muted;
  }

  if (!currentAudio) return;

  if (muted) {
    currentAudio.pause();
    // Keep video paused when audio is muted
    if (currentVideo) {
      currentVideo.pause();
    }
  } else {
    currentAudio.play().catch(console.error);
    // Video will start automatically via event listener
  }
}

export function stopAvatarSpeech() {
  avatarSpeaking = false;
  muted = false;

  // Stop and reset video to idle state
  if (currentVideo) {
    currentVideo.pause();
    currentVideo.currentTime = 0;
  }

  // Stop and cleanup audio
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;

    // CHANGED: remove the same listeners we added
    if (onAudioPlay) currentAudio.removeEventListener("play", onAudioPlay);
    if (onAudioPause) currentAudio.removeEventListener("pause", onAudioPause);
    if (onAudioEnded) currentAudio.removeEventListener("ended", onAudioEnded);
    if (onAudioError) currentAudio.removeEventListener("error", onAudioError);

    onAudioPlay = null;
    onAudioPause = null;
    onAudioEnded = null;
    onAudioError = null;

    URL.revokeObjectURL(currentAudio.src);
    currentAudio = null;
  }

  currentVideo = null;
}
